<template>
  <!--
    A barra que faz de "Liberação de funcionalidade" uma ABA de Avisos e
    Campanhas, e nao uma pagina solta com o mesmo nome no menu. Fica num
    componente proprio porque as duas listas a usam: duplicar o markup faria uma
    aba nova nascer em metade das telas.
  -->
  <div class="fw-tabs">
    <router-link class="fw-tab" :class="{ 'is-on': current === 'broadcasts' }"
                 to="/avisos-e-campanhas">Campanhas</router-link>
    <router-link class="fw-tab" :class="{ 'is-on': current === 'windows' }"
                 to="/avisos-e-campanhas/liberacoes">Liberação de funcionalidade</router-link>
  </div>
</template>

<script>
export default {
  name: "feature-window-tabs",
  props: {
    // 'broadcasts' ou 'windows'. Sem valor nenhuma aba fica marcada, o que e
    // melhor que marcar a errada.
    current: {type: String, default: ''},
  },
};
</script>

<style scoped>
.fw-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e6e7eb;
  margin-bottom: 16px;
}

.fw-tab {
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #4e5560;
  text-decoration: none;
  border-bottom: 2px solid transparent;
}

.fw-tab:hover,
.fw-tab:focus {
  color: #1d12b9;
  text-decoration: none;
}

.fw-tab.is-on {
  color: #1d12b9;
  border-bottom-color: #1d12b9;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/featureWindow/featureWindowTabs.vue